<script>
  import { createEventDispatcher, getContext } from "svelte";

  export let id = 1;
  export let palette = [];
  export let enabled = true;
  export let system = 0x00;

  const dispatch = createEventDispatcher();
  const popup = getContext("popup");

  let container;
  let value = updateValue(id, palette);
  $: value = updateValue(id, palette);

  function updateValue(id, palette) {
    return id == 0 ? false : palette[id];
  }
</script>

<div
  class="container"
  class:disabled={!enabled}
  class:transparent={id === 0}
  class:system1={system == 0x01}
  class:enabled
  bind:this={container}
  role="none"
  on:click={async (ev) => {
    if (enabled && !ev.shiftKey) {
      ev.preventDefault();
      if (popup) {
        const cur = popup.getCurrentPopup();
        if (
          cur &&
          cur.id == "color" &&
          cur.options.target === container &&
          cur.options.system === system
        ) {
          popup.cancel();
          return;
        }

        const result = await popup.select("color", {
          target: container,
          system,
          palette,
        });
        if (result) {
          dispatch("select", result);
        }
      }
    }
    if (ev.shiftKey) dispatch("shiftClick", ev);
  }}
  style={`--color: ${value || "none"}; --default-background: ${palette[0]}`}
>
  <div class="swatch"></div>
</div>

<style>
  .container {
    width: var(--swatch-cell-size);
    height: var(--swatch-cell-size);
    padding: 0px;
    border-radius: var(--border-radius);
    box-sizing: border-box;
    /* border: 1px solid black; */
    /* box-shadow:
      2px 0px 0px black,
      0px 2px 0px black,
      2px 2px 0px black; */
    opacity: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    opacity: 1;
    padding: 5px;
    /* background-color: white; */
    background: var(--default-background);
  }
  .disabled {
    visibility: hidden;
  }

  .swatch {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: 0px;
    background-color: var(--color);
  }
  .transparent {
  }
  .transparent .swatch {
    border: 1px dashed black;
  }
  .transparent.system1 .swatch {
    border-color: white;
  }

  .enabled {
    cursor: pointer;
    opacity: 1;
  }
</style>
